export default __webpack_public_path__ + "static/AGaramondPro-Italic-0e933137813faec2c2ad66085d0ebc07.ttf";